import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Input } from '../../../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'

export default function EditOperationForm({ params, setSelected, fetchOperations }) {
  const [open, setOpen] = useState(true)

  const {
    handleSubmit,
    control,

    reset,
  } = useForm({
    defaultValues: {
      id: params[0].id,
      Recette: params[0].Recette,
      Numero: params[0].Numero,
      Description: params[0].Description,
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(
      urls.crudInstructionOperations + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      fetchOperations()

      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Modifier Ingrédient</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Numero"
              label="Numero"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rows={4}
              multiline
              rules={{ required: true }}
              label="Instruction"
              name="Description"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
